/**
 * Centralized Application Configuration
 *
 * Update values here to apply changes across the entire application.
 * Fonts are injected as CSS custom properties on :root at app startup.
 */

const appConfig = {
  fonts: {
    /** Used for h1, h2 headings — Apple SF Pro (system font, no download needed) */
    heading: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", ui-sans-serif, sans-serif',
    /** Used for body text, inputs, buttons — everything else */
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
};

export default appConfig;
